<template>
    <div>
        <div class="referrals-datetime-title">
            <slot name="title">
                {{ title }}
            </slot>
        </div>
        <common-date class="referrals-datetime" :size="size" :date="appointmentDate" :copy="appointmentWeekday">
            <template #time>
                <common-icon v-if="showClockIcon" name="time" size="gigantic"></common-icon>
                <common-time :date="appointmentDate" :hasUnderline="true"></common-time>
            </template>
        </common-date>
    </div>
</template>
`
<script>
    import dayjs from 'dayjs'

    export default {
        props: {
            referral: { type: Object, required: true },
            size: { type: String, default: 'medium' },
            title: { type: String, default: '' },
        },

        inject: {
            isReferralPool: {
                default: false,
            },
        },

        computed: {
            appointmentDate() {
                if (this.isReferralPool) {
                    return dayjs(this.referral.createdAt)
                }
                return dayjs(this.referral.appointmentDateTime)
            },

            appointmentWeekday() {
                if (this.isReferralPool) {
                    dayjs(this.referral.createdAt).format('dddd')
                }
                return dayjs(this.referral.appointmentDateTime).format('dddd')
            },

            showClockIcon() {
                return this.size === 'small'
            },
        },
    }
</script>
